/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataDdlRequest } from './businessObjectDataDdlRequest';


export interface BusinessObjectDataDdlCollectionRequest { 
    businessObjectDataDdlRequests?: Array<BusinessObjectDataDdlRequest>;
}
